/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.AddVideoNoteAction.REQUEST_ADDVIDEONOTE:
      return {
        ...state,
    };
    case actions.AddVideoNoteAction.ADDVIDEONOTE_RECEIVED:
          return{
      ...state,
    };

    default:
      return state;
  }
};

export default reducer;
